class IndexPage {
    static newsIndex = 1;
    static newsCount = 0;

    /** @var Element */
    static root = null;

    static init() {
        IndexPage.root = document.querySelector('.index__news');

        IndexPage.newsIndex = 1;
        IndexPage.newsCount = IndexPage.root.querySelectorAll('.index__news__content .index__news__item').length;
    }

    static moveIndex(delta) {
        IndexPage.root.classList.remove(`index__news__show-${IndexPage.newsIndex}`);
        IndexPage.newsIndex += delta;
        IndexPage.newsIndex = (IndexPage.newsIndex === 0) ? IndexPage.newsCount : IndexPage.newsIndex;
        IndexPage.newsIndex = (IndexPage.newsIndex > IndexPage.newsCount) ? 1 : IndexPage.newsIndex;
        IndexPage.root.classList.add(`index__news__show-${IndexPage.newsIndex}`);
        console.log(IndexPage.newsIndex);
    }

    static scrollLeft() {
        return IndexPage.moveIndex(-1);
    }

    static scrollRight() {
        return IndexPage.moveIndex(+1);

    }
}
document.addEventListener('DOMContentLoaded', () => {
    document.querySelector('header div.header').classList.add('no-break');
    document.querySelector('main section.block-page_title').classList.add('no-break');

    IndexPage.init();
});